// add-link.js
;(({ $, $$ , log}) => {

    $$('.add-link[data-mode="button"]').forEach(tool => {
        const addButton = tool.querySelector('.add-link__add-button')
        const list = tool.querySelector('.add-link__list')
        const locale = tool.dataset.locale
        const linkType = tool.dataset.linkType
        const inputBasename = tool.dataset.inputBasename
        const inputBasename1 = tool.dataset.inputBasename1
        const inputBasename2 = tool.dataset.inputBasename2
        const placeholder1 = tool.dataset.placeholder1
        const placeholder2 = tool.dataset.placeholder2

        let linkCounter = parseInt(tool.dataset.startLinkCounter) || 1

        init()

        function init() {
            list.addEventListener('click', event => {
                const { target } = event

                if (isDeleteButton(target)) {
                    const input = target.closest('.control-wrapper')
                    if (input) {
                        removeNode(input)
                    }
                }
            })

            addButton.addEventListener('click', event => {
                event.preventDefault()

                const inputName = `video[${linkCounter}][${locale}][${inputBasename}]`
                const inputName1 = `link[${linkCounter}][${locale}][${inputBasename1}]`
                const inputName2 = `link[${linkCounter++}][${locale}][${inputBasename2}]`//`${inputBasename2}-${linkCounter++}-${locale}`

                const newInput = generateTemplate(linkType, {
                    placeholder1: placeholder1,
                    placeholder2: placeholder2,
                    name: inputName,
                    name1: inputName1,
                    name2: inputName2,
                })

                list.append(newInput)
            })
        }

        function generateTemplate(type, values) {
            if (type === 'simple') {
                const elem = document.createElement('div')

                'control-wrapper control-wrapper--outlined control-wrapper--with-additions control-wrapper--no-padding-right'.split(' ').forEach(s => {
                    elem.classList.add(s)
                })

                elem.innerHTML = `
                    <div class="control-wrapper__control">
                        <input class="input input--medium" type="text" name="${values.name}" autocomplete="off" placeholder="${values.placeholder1}">
                        <button class="control-wrapper__right-button add-link__remove-button"></button>
                    </div>
                `
                return elem

            } else if (type === 'couple') {
                const elem = document.createElement('div')

                'control-wrapper control-wrapper--outlined control-wrapper--with-additions control-wrapper--no-padding-right'.split(' ').forEach(s => {
                    elem.classList.add(s)
                })

                elem.innerHTML = `
                    <div class="control-wrapper__control">
                        <div class="control-wrapper__couple">
                            <input class="input input--medium" type="text" name="${values.name1}" autocomplete="off" placeholder="${values.placeholder1}">
                            <input class="input input--medium" type="text" name="${values.name2}" autocomplete="off" placeholder="${values.placeholder2}">
                        </div>
                        <button class="control-wrapper__right-button add-link__remove-button"></button>
                    </div>
                `
                return elem
            }

            return null
        }
    })

    $$('.add-link[data-mode="select"]').forEach(tool => {
        const addSelect = tool.querySelector('.add-link__select')
        const list = tool.querySelector('.add-link__list')
        const locale = tool.dataset.locale
        const placeholder = tool.dataset.placeholder
        const options = tool.querySelectorAll('.custom-select__option')

        init()

        function init() {
            updateOptions()

            list.addEventListener('click', event => {
                const { target } = event

                if (isDeleteButton(target)) {
                    const input = target.closest('.control-wrapper')
                    if (input) {
                        removeNode(input)
                        updateOptions()
                    }
                }

            })

            addSelect.addEventListener('change', event => {
                const { value } = event

                const inputName = `${value.toLowerCase()}_${locale}`

                const newInput = generateTemplate({
                    value,
                    name: inputName,
                    placeholder
                })

                list.append(newInput)
                updateOptions()
            })
        }

        function generateTemplate(values) {
            const elem = document.createElement('div')
            elem.setAttribute('data-value', values.value)
            'control-wrapper control-wrapper--outlined control-wrapper--with-additions control-wrapper--no-padding-right'.split(' ').forEach(s => {
                elem.classList.add(s)
            })
            elem.innerHTML = `
                <div class="control-wrapper__control">
                <div class="control-wrapper__couple">
                    <input class="input input--medium" type="text" readonly value="${values.value}">
                    <input class="input input--medium" type="text" name="${values.name}" autocomplete="off" placeholder="${values.placeholder}">
                </div>
                <button class="control-wrapper__right-button add-link__remove-button js-no-submitter"></button>
            </div>
            `
            return elem
        }

        function updateOptions() {

            const addedOptions = []
            list.querySelectorAll('.control-wrapper').forEach(addedOption => {
                addedOptions.push(addedOption.dataset.value)
            })

            options.forEach(option => {
                const value = option.dataset.roValue
                if (addedOptions.includes(value)) {
                    option.style.display = 'none'
                } else {
                    option.removeAttribute('style')
                }
            })
        }
    })


    function isDeleteButton(el) {
        return el.classList.contains('add-link__remove-button')
    }

    function removeNode(el) {
        el.parentNode.removeChild(el)
    }
})(CNS);
